export default __webpack_public_path__ + "static/media/wash-icon-warning-banner.1a36f68e.svg";